import { createAri } from '@atlassian/jira-platform-ari/src/index.tsx';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import QUERY, {
	type viewBacklogCustomFiltersQuery,
} from '@atlassian/jira-software-backlog/src/view/header/controls-bar/filter-bar/custom-filters/__generated__/viewBacklogCustomFiltersQuery.graphql';
import { RESOURCE_TYPE_NEXTGEN_BACKLOG_CUSTOM_FILTERS } from '../../constants.tsx';

export const customFiltersResource = createRelayResource<viewBacklogCustomFiltersQuery>({
	type: RESOURCE_TYPE_NEXTGEN_BACKLOG_CUSTOM_FILTERS,
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: QUERY,
		variables: {
			boardId: createAri({
				resourceOwner: 'jira-software',
				cloudId: tenantContext.cloudId,
				resourceType: 'board',
				resourceId: String(match.params.boardId),
			}),
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
	captureErrors: true,
	isBrowserOnly: true,
});
